import { Component, Input, ViewChild, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SliderComponent),
      multi: true
    }
  ],
})
export class SliderComponent implements OnInit, ControlValueAccessor  {

  @Input() value;
  @Input() scale: number[] = [0,10,20,30,40,50,60,70,80,90,100];
  @Input() prefix;
  @Input() suffix;
  @ViewChild('rootNode') rootNode;

  min: number;
  max: number;
  position: number;
  grabbing: boolean = false;
  leftBounding: number;
  rightBounding: number;

  onMoveClosured: (event) => void;
  stopClosured: (event) => void;
  onChange = (value) => {};
  onTouched = () => {};

  ngOnInit() {
    this.min = Math.min.apply(null, this.scale);
    this.max = Math.max.apply(null, this.scale);
    this.onMoveClosured = event => this.onMove(event);
    this.stopClosured = event => this.stop(event);

    if (! this.value) {
      this.value = this.min;
    }
  }

  start(event) {
    this.grabbing = true;
    this.leftBounding = this.rootNode.nativeElement.getBoundingClientRect().left;
    this.rightBounding = this.rootNode.nativeElement.getBoundingClientRect().right;
    window.document.addEventListener('mousemove', this.onMoveClosured);
    window.document.addEventListener('mouseup', this.stopClosured);
    window.document.addEventListener('mouseleave', this.stopClosured);
    window.document.addEventListener('touchmove', this.onMoveClosured);
    window.document.addEventListener('touchend', this.stopClosured);

    this.onMove(event);
  }

  stop(event) {
    this.grabbing = false;
    window.document.removeEventListener('mousemove', this.onMoveClosured);
    window.document.removeEventListener('mouseup', this.stopClosured);
    window.document.removeEventListener('mouseleave', this.stopClosured);
    window.document.removeEventListener('touchmove', this.onMoveClosured);
    window.document.removeEventListener('touchend', this.stopClosured);
  }

  onMove(event) {
    const touch = event.touches ? event.touches[0] : event;
    const position = (touch.clientX - this.leftBounding) / (this.rightBounding - this.leftBounding);
    this.writeValue(this.getClosest(position*(this.max - this.min) + this.min));
    this.onChange(this.value);
  }

  getClosest(value) {
    return this.scale.reduce((prev, current) => Math.pow(value - current, 2) > Math.pow(value - prev, 2) ? prev : current);
  }

  writeValue(value) {
    this.value = value;
    if (value === null) {
      this.position = 0;
    } else {
      this.position = (value - this.min) / (this.max - this.min);
    }
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/slider/slider.component.ts